export default "__VITE_ASSET__CAEkyoZE__"